var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButonFramed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Buton-Cerceveli") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-369.000000, -2324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buton-Cerceveli",
    transform: "translate(370.000000, 2325.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#464646",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61165365,15.6218262 L9.60799154,12.8646647 L13.2486979,12.8646647 L14.182373,15.6218262 L15.5484212,15.6218262 L12.2084961,6.41666667 L10.798584,6.41666667 L7.33333333,15.6218262 L8.61165365,15.6218262 Z M12.8476562,11.849528 L9.96516927,11.849528 L11.4502767,7.78271484 L12.8476562,11.849528 Z",
    id: "A",
    fill: "#464646",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButonFramed);
export default __webpack_public_path__ + "static/media/Buton-Framed.fbe468d2299b72e7dda25f654546dbea.svg";
export { ForwardRef as ReactComponent };